import { render, staticRenderFns } from "./FormPage.vue?vue&type=template&id=e48d015e&"
import script from "./FormPage.vue?vue&type=script&lang=ts&"
export * from "./FormPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e48d015e')) {
      api.createRecord('e48d015e', component.options)
    } else {
      api.reload('e48d015e', component.options)
    }
    module.hot.accept("./FormPage.vue?vue&type=template&id=e48d015e&", function () {
      api.rerender('e48d015e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistic/product-category/FormPage.vue"
export default component.exports